module.exports = __webpack_public_path__ + "img/clothing_fashion.3ce1e8ff.png";